import React from 'react';
import { SPORTS } from 'constants/appConfig';
import { ActivePlayerName, EventNameExtraInfo } from './styled';
import { formatPlayerName, isMarketOverUnder } from 'utils/Helper';
import RedCardIcon from 'images/icons/red_card.svg';
import { APP_PATH, MARKET_TYPE_GROUPS_ID } from '../../constants/appConfig';
import { trackEvents } from '../../helpers/VaixHelpers/VaixTracking';
import {
    VAIX_TRACKING_LOCATION_FOR_TYPE_OF_SPORT,
    VAIX_TRACKING_TYPE,
} from '../../constants/vaix/VaixTrcakingConstants';
import { browserHistory } from 'react-router';
import { ThreeDots } from '../../styled';

export const isEventThisWeek = (timestamp) => {
    const now = new Date();
    const eventDate = new Date(timestamp);

    const nextWeek = new Date(now);
    nextWeek.setDate(now.getDate() + 6);
    nextWeek.setHours(23, 59, 59, 999);

    return eventDate >= now && eventDate <= nextWeek;
};

export const openGamePage = (eventObj, userId = 0) => {
    if (eventObj && eventObj?.vaixIndex && eventObj?.vaixIndex > 0) {
        trackEvents(
            eventObj,
            VAIX_TRACKING_TYPE.clickEvent,
            VAIX_TRACKING_LOCATION_FOR_TYPE_OF_SPORT(eventObj.sport),
            '/live',
            userId,
            0,
            eventObj?.vaixIndex
        );
    }

    if (eventObj.live && eventObj.status <= 0) {
    } else {
        browserHistory.push('/sport/kamp/' + eventObj.eventId);
    }
};

export const isShowOUMarkets = (event, isMobile, contentWidth) => {
    return (
        event.sportId === SPORTS.FOOTBALL &&
        !isMobile &&
        contentWidth > 625 &&
        event.marketList?.[0] &&
        event.marketList.some(isMarketOverUnder)
    );
};

export const getMarketCountLabel = (event, isMobile, contentWidth) => {
    let showCount =
        event.marketList?.[0] &&
        event.marketList.some(
            (item) => item.marketTypeGroup === MARKET_TYPE_GROUPS_ID._1X2
        )
            ? 1
            : 0;

    const showOUMarkets = isShowOUMarkets(event, isMobile, contentWidth);

    if (showOUMarkets) {
        showCount += 1;
    }
    const marketsLeftCount = event.marketCount - showCount;
    return marketsLeftCount > 0 ? `+${marketsLeftCount}` : '';
};

const getRedCards = (ev, teamIndex) => {
    if (
        ev.sportId === SPORTS.FOOTBALL &&
        ev.liveScore &&
        (ev.liveScore.homeRedCard || ev.liveScore.awayRedCard)
    ) {
        const isHomeRedCard = ev.liveScore.homeRedCard > 0 && teamIndex === '1';
        const isAwayRedCard = ev.liveScore.awayRedCard > 0 && teamIndex === '2';

        return (
            (isHomeRedCard || isAwayRedCard) && (
                <img
                    src={RedCardIcon}
                    alt="Red card icon"
                    data-name="Rectangle 336"
                    style={{ marginLeft: '4px' }}
                />
            )
        );
    }

    return null;
};

export const getTeamName = (ev, teamIndex) => {
    if (
        ev.sportId === SPORTS.TENNIS &&
        ev.liveScore &&
        ev.liveScore.extraInfo &&
        teamIndex === ev.liveScore.extraInfo.server
    ) {
        return (
            <EventNameExtraInfo>
                <ActivePlayerName>
                    <ThreeDots>
                        {teamIndex === '1'
                            ? formatPlayerName(ev.homeTeam)
                            : formatPlayerName(ev.awayTeam)}
                    </ThreeDots>
                </ActivePlayerName>

                <img
                    className="active-player-icon"
                    src={APP_PATH + '/img/sports/5.png'}
                    width="10"
                    height="10"
                    alt="5"
                />
            </EventNameExtraInfo>
        );
    } else if (
        ev.sportId === SPORTS.FOOTBALL &&
        ev.liveScore &&
        (ev.liveScore.homeRedCard || ev.liveScore.awayRedCard)
    ) {
        return (
            <ActivePlayerName>
                <ThreeDots>
                    {teamIndex === '1' ? ev.homeTeam : ev.awayTeam}
                </ThreeDots>
                {getRedCards(ev, teamIndex)}
            </ActivePlayerName>
        );
    } else {
        return (
            <ActivePlayerName>
                <ThreeDots>
                    {teamIndex === '1'
                        ? formatPlayerName(ev.homeTeam)
                        : formatPlayerName(ev.awayTeam)}
                </ThreeDots>
                {getRedCards(ev, teamIndex)}
            </ActivePlayerName>
        );
    }
};
